export default "__VITE_ASSET__Dk56z1Vf__"